
import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { SimulationConfig } from './types';

interface ControlIslandProps {
  isPlaying: boolean;
  setIsPlaying: (p: boolean) => void;
  onReset: () => void;
  config: SimulationConfig;
}

export const ControlIsland: React.FC<ControlIslandProps> = ({ 
  isPlaying, setIsPlaying, onReset, config 
}) => {
  return (
    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-40 flex items-center gap-4 pointer-events-none">
       <motion.div 
         initial={{ y: 50, opacity: 0 }}
         animate={{ y: 0, opacity: 1 }}
         className="hardware-surface glow-active flex items-center gap-1 p-1.5 pointer-events-auto shadow-2xl"
       >
         <button 
           onClick={() => setIsPlaying(!isPlaying)}
           className={`w-14 h-14 rounded-2xl flex items-center justify-center transition-all duration-300 group relative overflow-hidden ${
             isPlaying 
             ? (config.darkMode ? 'bg-zinc-800 text-white hover:bg-zinc-700' : 'bg-white text-zinc-900 shadow-inner border border-zinc-100') 
             : 'bg-indigo-600 text-white hover:bg-indigo-500 shadow-[0_0_20px_rgba(79,70,229,0.4)]'
           }`}
         >
           <AnimatePresence mode="wait">
             <motion.i 
               key={isPlaying ? 'pause' : 'play'}
               initial={{ scale: 0.5, opacity: 0, rotate: -45 }}
               animate={{ scale: 1, opacity: 1, rotate: 0 }}
               exit={{ scale: 0.5, opacity: 0, rotate: 45 }}
               className={`fa-solid ${isPlaying ? 'fa-pause' : 'fa-play'} text-xl relative z-10`}
             ></motion.i>
           </AnimatePresence>
           {!isPlaying && (
             <motion.div 
               layoutId="playHighlight"
               className="absolute inset-0 bg-white/10 animate-pulse pointer-events-none" 
             />
           )}
         </button>

         <div className="w-px h-8 bg-white/10 mx-1" />

         <button 
           onClick={onReset}
           className={`w-14 h-14 rounded-2xl flex items-center justify-center transition-all duration-500 hover:rotate-180 active:scale-90 ${
             config.darkMode ? 'text-white/60 hover:text-white hover:bg-white/10' : 'text-zinc-500 hover:text-zinc-900 hover:bg-zinc-100'
           }`}
         >
            <i className="fa-solid fa-rotate-right text-xl"></i>
         </button>
       </motion.div>
    </div>
  );
};
